import * as React from "react";
import { cn } from "@/lib/utils";
import type { NotifyEmptyProps } from "@/types/notify.types";

export const Empty = React.forwardRef<
  HTMLDivElement,
  NotifyEmptyProps & React.HTMLAttributes<HTMLDivElement>
>(({ icon, title, description, action, variant = "card", className, ...rest }, ref) => (
  <div
    ref={ref}
    className={cn(
      "flex flex-col items-start gap-2",
      variant === "card"
        ? "rounded-md border border-dashed border-border-default bg-bg-muted-rd p-6"
        : "py-3",
      className
    )}
    {...rest}
  >
    {icon ? <div className="mb-1 text-text-tertiary">{icon}</div> : null}
    <div className="text-[14px] font-medium text-text-primary">{title}</div>
    {description ? <div className="text-[12px] text-text-secondary">{description}</div> : null}
    {action ? <div className="mt-2 flex items-center gap-2">{action}</div> : null}
  </div>
));
Empty.displayName = "NotifyEmpty";
